import React from 'react';
import './Presentation.css'; // Import the CSS file for styling

function Presentation() {
  return (
    <div className="presentation-container">
      <iframe 
        src="https://www.miricanvas.com/v/12tyryo" 
        title="Presentation Frame"
        frameborder="0"
        allowfullscreen
      ></iframe>
    </div>
  );
}

export default Presentation;